import { useCallback } from 'react';
import type { MutableRefObject } from 'react';

export function useScrollToSection(visibleSectionsRef: MutableRefObject<HTMLElement[]>) {
  return useCallback(
    (selector: string) => {
      const section =
        visibleSectionsRef.current?.find((candidate) => candidate.matches(selector)) ??
        Array.from(document.querySelectorAll<HTMLElement>(selector)).find(
          (candidate) => getComputedStyle(candidate).getPropertyValue('display') !== 'none',
        );

      if (!section) return;

      const scrollTargetBlock = section.offsetHeight >= window.innerHeight / 2 ? 'start' : 'center';
      const scrollTarget = section.querySelector<HTMLElement>(`[data-scroll-target=${scrollTargetBlock}]`);

      if (!scrollTarget) return;

      scrollTarget.scrollIntoView({
        behavior: 'smooth',
        inline: 'start',
        block: scrollTargetBlock,
      });
    },
    [visibleSectionsRef],
  );
}
